<template lang="pug">
    div(v-if="currentStep.rows")
        lessonHeader
        stepTitle
        div.Infographics-initial-text {{currentStep.initialText}}
        v-spacer.py-2        
        v-layout.Infographics-items-container(row wrap v-for="row in currentStep.rows")
            v-flex(xs6 v-for="item in row.items")                
                v-layout(row wrap)
                    v-flex.Infographics-image-container(xs12 lg4 md4)
                        v-img(:src="require(`@/assets/${item.image}`)")
                        div.Infographics-visited(v-show="item.visited")
                            v-icon.Infographics-visited-icon(size="27" color="white") check
                    v-flex.Infographics-section-rigth(xs12 lg8 md8)
                        div.Infographics-section-title(v-html="item.title")
                        viewMoreButton(@click="visitItem(item)").Infographics-view-more-button.mt-2
        el-button.Infographics-next-button(@click="next" type="primary" :disabled="disabled") Siguiente
</template>
<script>
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title';
import viewMoreButton from '@/components/view-more-button/view-more-button';

import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'Infographics',
  components:{
	lessonHeader,    
    stepTitle,
    viewMoreButton 
  },
  computed: {
      ...mapGetters(['currentStep', 'currentGroup'])
  },
  methods: {
      ...mapActions(['nextStepSCORM']),
      ...mapMutations(['setCurrentStep']),
      visitItem(item) {          
          item.visited = true;          
          let visitedItems = 0;
          this.currentStep.rows.forEach(r => {
              r.items.forEach(i => {
                if(i.visited) {
                    visitedItems++;
                }
              });              
          });
          this.disabled = visitedItems < 6
          this.nextStepSCORM({params: item, transition: 'slide'});
      },
      next() {              
        const step = this.currentGroup.steps[this.currentStep.index + 2];
        this.setCurrentStep(step);
    }
  },
  data() {
      return {
          disabled: true              
      }
  },
}
</script>

<style scoped>
@import 'infographics.scss';
</style>
